import { render, staticRenderFns } from "./AccessRequest.vue?vue&type=template&id=725d431b&"
import script from "./AccessRequest.vue?vue&type=script&lang=js&"
export * from "./AccessRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports